<ng-snotify></ng-snotify>
<app-loader></app-loader>
<ps-progress-bar [progressBarValue]="progressBarValue" [progressbarStatus]="progressbarStatus"></ps-progress-bar>
<router-outlet></router-outlet>
